"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelClass = exports.dropDownClass = exports.containerClass = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var containerClass = exports.containerClass = function containerClass(props, state) {
  return (0, _classnames["default"])({
    'ui-date-field': true,
    'ui-form-field': true,
    'ui-form-field--inline': props.inline,
    'ui-form-field--has-error': props.hasError,
    'ui-form-field--disabled': props.disabled,
    'ui-date-field--has-error': props.hasError,
    'ui-date-field--droptdown-open': state.isOpen
  }, props.className);
};
var labelClass = exports.labelClass = function labelClass(props) {
  return (0, _classnames["default"])(_defineProperty(_defineProperty({
    'ui-form-field__label': true,
    'ui-form-field__label--required': props.required
  }, props.labelClassName, !(0, _lodash.isEmpty)(props.labelClassName)), 'sr-only', props.hideLabel));
};
var dropDownClass = exports.dropDownClass = function dropDownClass(state) {
  return (0, _classnames["default"])({
    'ui-date-field__dropdown': true,
    'ui-date-field__dropdown--open': state.isOpen
  });
};